module.exports = __webpack_public_path__ + "static/media/banner_home_cotizacion.2ba0d0bb.jpg";